module.exports = __webpack_public_path__ + "5e6527638858205ca0f576074c8c8f2f.svg";